import {
  FETCH_MAILS_REQUEST,
  FETCH_MAILS_SUCCESS,
  FETCH_MAILS_FAILURE
} from './mail'

const initialState = {
  mails: [],
  message: null,
  loading: false,
  error: null
}

export default function mailReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MAILS_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_MAILS_SUCCESS:
      return { ...state, loading: false, error: null, message: action.payload }
    case FETCH_MAILS_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}
